import styled from "styled-components";
import { FontFamily, Size } from "static/coreStyles/theme.styled";

export const AddAdsContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  .ad-star {
    position: absolute;
    top: -6px;
    right: 8px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
  .app-icon {
    width: 12px;
    height: 12px;
    margin-right: 2px;
    margin-bottom: 1px;
    margin-top: 1px;
  }
  .icon-container {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    padding: 4px;
    width: 38px;
    height: 38px;
    border: dashed 1px #6fa2f4;
    border-radius: 6px;
  }
  .app-name {
    font-family: ${FontFamily.Medium};
    font-size: ${Size.xs};
    font-weight: 500;
    color: #636970;
    margin-top: 9px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70px;
  }
`;
